import { UseFetchOptions } from '#app'
import { NavigateToOptions } from '#app/composables/router'
import { RouteLocationNormalizedLoaded } from 'vue-router'

interface UseRedirectArguments {
    url: string
}

interface UseRedirectResult {
    error: boolean
    data: {
        url: string | undefined,
        options: NavigateToOptions | undefined
    }
}

const getRedirect = async ({ url }: UseRedirectArguments): Promise<UseRedirectResult> => {
    const result = ref<UseRedirectResult>({
        error: true,
        data: {
            url: undefined,
            options: undefined,
        }
    })

    const redirect = await
        $fetch(
        '/api/redirect',
        {
            params: {
                slug: url,
            },
        }
    )

    if (redirect?.exists) {
        result.value.error = false
        result.value.data.url = redirect.new_url
        result.value.data.options = {
            redirectCode: Number(redirect.redirect_code),
            external: redirect.new_url.search('^http') >= 0,
        }
    }

    return result.value
}

export async function useFetchWithRedirect<ResT>(url: string | Request | Ref<string | Request> | (() => string | Request), redirectOptions: {route: RouteLocationNormalizedLoaded, onNotFound?: () => void}, reqOptions?: UseFetchOptions<ResT>) {
    const data = await useLazyFetch<ResT>(url, reqOptions as any)
    let redirect : UseRedirectResult | undefined = undefined
    if (data.error.value) {
        try {
            redirect = await getRedirect({ url: redirectOptions.route.fullPath })
            if (redirect.error) {
                if (redirectOptions.onNotFound) {
                    redirectOptions.onNotFound()
                } else {
                    showError({ statusCode: 404 })
                }
            }
        } catch (error) {
            if (redirectOptions.onNotFound) {
                redirectOptions.onNotFound()
            } else {
                showError({ statusCode: 404 })
            }
        }
    }
    return { ...data, redirect }
}
